<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="6" :sm="12">
            <a-form-item label="群名称">
              <a-input
                placeholder="输入群名称查询"
                v-model="queryParam.groupName"
              ></a-input>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="12">
            <a-form-item label="群主">
              <a-input
                placeholder="输入创建人查询"
                v-model="queryParam.founder"
              ></a-input>
            </a-form-item>
          </a-col>

          <!-- <div v-if="toggleSearchStatus">
            <a-col :md="6" :sm="12">
              <a-form-item label="客户名称">
                <a-input placeholder="输入创建人查询" v-model="queryParam.customer"></a-input>
              </a-form-item>
            </a-col>

             <a-col :md="6" :sm="12">
              <a-form-item label="内部员工">
                <a-input placeholder="输入创建人查询" v-model="queryParam.intstaff"></a-input>
              </a-form-item>
            </a-col>
          </div> -->

          <a-col :md="toggleSearchStatus ? 24 : 6" :sm="8">
            <span
              style="float: right; overflow: hidden"
              class="table-page-search-submitButtons"
            >
              <a-button type="primary" @click="searchQuery" icon="search"
                >查询</a-button
              >
              <a-button
                type="primary"
                @click="searchReset"
                icon="reload"
                style="margin-left: 8px"
                >重置</a-button
              >
              <!--展开按钮，控制toggleSearchStatus状态-->
              <!-- <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'" />
              </a> -->
              <!--展开按钮结束-->
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
        <i class="anticon anticon-info-circle ant-alert-icon"></i>已选择&nbsp;<a
          style="font-weight: 600"
          >{{ selectedRowKeys.length }}</a
        >项&nbsp;&nbsp;
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        bordered
        size="middle"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange
        }"
        :rowKey="r => r.chat_id"
        @change="handleTableChange"
      >
        <div
          :style="{
            maxWidth: '180px',
            wordWrap: 'break-word',
            wordBreak: 'break-all'
          }"
          slot="notice"
          slot-scope="text, record"
        >
          <a-tooltip placement="left">
            <template slot="title">
              <span>{{ record.notice }}</span>
            </template>
            {{
              !record.notice
                ? '--'
                : record.notice.length > 20
                ? record.notice.substr(0, 20) + '...'
                : record.notice
            }}
          </a-tooltip>
        </div>
        <span slot="erwei" slot-scope="text, record">
          <a @click="openCode(record)" v-if="record.imageName">查看</a>
          <a-divider type="vertical" v-if="record.imageName" />
          <a @click="uploadCode(record)">{{
            record.imageName ? '更新' : '上传'
          }}</a>
        </span>
        <!-- 不上线暂时隐藏 -->
        <span slot="action" slot-scope="text, record">
          <a @click="seeGroupMember(record)">群成员</a>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link"> 更多<a-icon type="down" /> </a>
            <a-menu slot="overlay">
              <!-- :disabled="record.statusNum==='1'?false:true" -->
              <!-- <a-menu-item :disabled="record.statusNum===null?false:true" @click="distribution(record)">离职分配</a-menu-item> -->
              <!-- <a-menu-item @click="jumpChatDataView(record)">消息查看</a-menu-item> -->
              <!-- <a-menu-item >群成员</a-menu-item> -->
              <a-menu-item @click="showDetial(record)">群详情</a-menu-item>
              <a-menu-item @click="courseManage(record)">课程管理</a-menu-item>
              <!-- <a-menu-item @click="uploadCode(record)">上传二维码</a-menu-item>
                <a-menu-item @click="openCode(record)" v-if="record.imageName">查看二维码</a-menu-item> -->
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
      <customer-window ref="customerWindow" @ok="modalFormOk"></customer-window>
      <course-manage-modal
        ref="courseManageModal"
        @ok="modalFormOk"
      ></course-manage-modal>
      <chat-detail
        :record="record"
        :showorhidden="showorhidden"
        @ok="showorhidden = !showorhidden"
      ></chat-detail>

      <a-modal
        title="群成员列表"
        :closable="false"
        :visible="visibleGroupMemberChat"
        @cancel="onCloseGroupChat"
        @ok="onCloseGroupChat"
        :width="1200"
      >
        <!-- <a-form layout="inline">
          <a-row :gutter="24">
            <a-col :md="6" :sm="12">
              <a-form-item label="群成员名称">
                <a-input placeholder="输入群名称查询"></a-input>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="12">
              <a-form-item label="开户状态">
                <a-input placeholder="输入群名称查询"></a-input>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form> -->
        <!-- <a-divider /> -->
        <a-table
          :columns="columnsGroupChat"
          :data-source="dataGroupChat"
          :pagination="false"
        >
        </a-table>
      </a-modal>
    </div>
    <a-modal
      title="上传二维码"
      :visible="visibleCode"
      @ok="handleOkCode"
      @cancel="handleCancelCode"
    >
      <j-image-upload
        file-type="file"
        accept=".jpg, .png"
        text="上传"
        fileKey="picFile"
        v-model="picUrl"
        url="wechatwork-customer-biz/wechatwork/customerGroupChat/uploadDimensionalBarcode"
        @getFileList="_getFileList"
      >
      </j-image-upload>
    </a-modal>
    <a-modal
      v-model="visibleOpenCode"
      title="查看二维码"
      :footer="null"
      centered
    >
      <img
        :src="URL"
        alt=""
        width="200px"
        style="margin: 0 auto; display: block"
      />
    </a-modal>
  </a-card>
</template>

<script>
import { getFileAccessHttpUrl, getAction, postAction } from '@/api/manage';
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import moment from 'moment';
import customerWindow from './CustomerWindow';
import chatDetail from './chatDetail';
import courseManageModal from '../course/courseManageModal';
import { transfer } from '@/api/api';
import JImageUpload from '../../../components/jeecg/JImageUpload';
import { axios } from '@/utils/request';
// import { postAction } from '../../../api/manage';

export default {
  name: 'ChatRoomList',
  mixins: [JeecgListMixin],
  components: {
    customerWindow,
    courseManageModal,
    JImageUpload,
    chatDetail
  },
  data() {
    return {
      codeUrl: '',
      picUrl: '',
      URL: '',
      visibleOpenCode: false,
      visibleCode: false,
      multipartFile: '',
      groupChatId: '',
      description: '客户群页面',
      queryParam: {},
      recycleBinVisible: false,
      columns: [
        {
          title: '群名称(群人数)',
          align: 'center',
          dataIndex: 'name',
          customRender: function(text, record, index) {
            if (text != null) {
              return `${text}(${record.groupMemberNum}人)`;
            } else {
              return text;
            }
          }
        },
        {
          title: '群主',
          align: 'center',
          dataIndex: 'ownerName',
          customRender: function(text, record, index) {
            if (!text) {
              return '--';
            } else {
              return text;
            }
          }
        },
        {
          title: '状态',
          align: 'center',
          dataIndex: 'status',
          customRender: function(text, record, index) {
            if (!text) {
              return '--';
            } else {
              return text;
            }
          }
        },
        // {
        //   title: '今日入群/退群',
        //   align: 'center',
        //   dataIndex: '',
        // },
        {
          title: '内部员工',
          align: 'center',
          dataIndex: 'employeeCount'
        },
        // customRender: function (text, record, index) {
        //   if (text != null) {
        //     return moment(Number(text)*1000).format('YYYY-MM-DD HH:mm:ss');
        //   } else {
        //     return text;
        //   }
        // }
        // {
        //   title: '开户人数',
        //   align: 'center',
        //   dataIndex: 'groupMemberNum',
        //   // customRender: function (text, record, index) {
        //   //   if (text == null) {
        //   //     return '-'
        //   //   } else {
        //   //     return text.length>20?text.substr(0,20)+"...":text
        //   //   }
        //   // },
        //   // scopedSlots: {customRender: 'notice'}
        // },
        // {
        //   title: '群人数',
        //   align: "center",
        //   width: 100,
        //   dataIndex: 'groupMemberNum'
        // },
        // {
        //   title: '群聊预警',
        //   align: 'center',
        //   dataIndex: 'chatErr',
        // },
        {
          title: '群消息数',
          align: 'center',
          dataIndex: 'groupMessageNum',
          customRender: function(text, record, index) {
            if (text == null) {
              return 0;
            } else {
              return text;
            }
          }
          // sorter: (a, b) => a.groupMessageNum - b.groupMessageNum
        },
        {
          title: '群二维码',
          align: 'center',
          dataIndex: 'lastGroupMessageTime',
          scopedSlots: { customRender: 'erwei' }
        },
        {
          title: '建群时间',
          align: 'center',
          dataIndex: 'create_time',
          customRender: function(text, record, index) {
            if (text == null) {
              return '-';
            } else {
              return text;
            }
          }
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          align: 'center',
          width: 140
        }
      ],
      url: {
        list:
          process.env.VUE_APP_CMS_WECHATCUSTOMER +
          '/wechatwork/customerGroupChat/data',
        groupChatMember:
          process.env.VUE_APP_CMS_WECHATCUSTOMER +
          '/wechatwork/customerGroupChat/getMemberById',
        fileUpload:
          process.env.VUE_APP_CMS_WECHATCUSTOMER +
          '/wechatwork/customerGroupChat/updateGroupDimensionalBarcode',
        showGroupDimensionalBarcode:
          process.env.VUE_APP_CMS_WECHATCUSTOMER +
          '/wechatwork/customerGroupChat/showGroupDimensionalBarcode'
      },
      visibleGroupMemberChat: false,
      dataGroupChat: [
        {
          name: '张三',
          poptype: '企业成员',
          otherchat: '12个',
          thisnum: '12',
          err: '12',
          allnum: '12',
          jointype: '邀请入群',
          jointime: '2020-12-12 12:00',
          opentype: '已开户',
          qtime: '2020-12-12 12:00'
        },
        {
          name: '张三',
          poptype: '企业成员',
          otherchat: '12个',
          thisnum: '12',
          err: '12',
          allnum: '12',
          jointype: '邀请入群',
          jointime: '2020-12-12 12:00',
          opentype: '已开户',
          qtime: '2020-12-12 12:00'
        },
        {
          name: '张三',
          poptype: '企业成员',
          otherchat: '12个',
          thisnum: '12',
          err: '12',
          allnum: '12',
          jointype: '邀请入群',
          jointime: '2020-12-12 12:00',
          opentype: '已开户',
          qtime: '2020-12-12 12:00'
        },
        {
          name: '张三',
          poptype: '企业成员',
          otherchat: '12个',
          thisnum: '12',
          err: '12',
          allnum: '12',
          jointype: '邀请入群',
          jointime: '2020-12-12 12:00',
          opentype: '已开户',
          qtime: '2020-12-12 12:00'
        },
        {
          name: '张三',
          poptype: '企业成员',
          otherchat: '12个',
          thisnum: '12',
          err: '12',
          allnum: '12',
          jointype: '邀请入群',
          jointime: '2020-12-12 12:00',
          opentype: '已开户',
          qtime: '2020-12-12 12:00'
        },
        {
          name: '张三',
          poptype: '企业成员',
          otherchat: '12个',
          thisnum: '12',
          err: '12',
          allnum: '12',
          jointype: '邀请入群',
          jointime: '2020-12-12 12:00',
          opentype: '已开户',
          qtime: '2020-12-12 12:00'
        }
      ],
      columnsGroupChat: [
        {
          title: '群成员名称',
          align: 'center',
          dataIndex: 'name',
          customRender: function(text, record, index) {
            if (text) {
              return text;
            } else {
              return '未知群成员_' + index;
            }
          }
        },
        {
          title: '群成员类型',
          align: 'center',
          dataIndex: 'type',
          customRender: function(text, record, index) {
            if (text == 1) {
              return '企业成员';
            } else if (text == 2) {
              return '外部联系人';
            }
          }
        },
        {
          title: '群成员累计消息数',
          align: 'center',
          dataIndex: 'otherGroupMessageNumber',
          customRender: function(text, record, index) {
            if (text == null) {
              return 0;
            } else {
              return text;
            }
          }
        },
        {
          title: '群内消息数量',
          align: 'center',
          dataIndex: 'currentGroupMessageNumber',
          customRender: function(text, record, index) {
            if (text == null) {
              return 0;
            } else {
              return text;
            }
          }
        },
        // {
        //   title: '触发预警',
        //   align: 'center',
        //   dataIndex: 'err',
        // },
        {
          title: '群成员群聊总数',
          align: 'center',
          dataIndex: 'groupChatCount',
          customRender: function(text, record, index) {
            if (text == null) {
              return 0;
            } else {
              return text;
            }
          }
        },
        {
          title: '入群方式',
          align: 'center',
          dataIndex: 'joinScene',
          customRender: function(text, record, index) {
            if (text == 1) {
              return '成员邀请';
            } else if (text == 2) {
              return '链接申请';
            } else if (text == 3) {
              return '扫描二维码';
            }
          }
        },
        {
          title: '入群时间',
          align: 'center',
          dataIndex: 'joinTime'
        }
        // {
        //   title: '退群时间',
        //   align: 'center',
        //   dataIndex: 'qtime',
        // },
      ],
      showorhidden: false,
      record: {}
    };
  },
  computed: {
    importExcelUrl: function() {
      return `${process.env.GATEWAY + process.env.VUE_APP_CMS_SYSTEM}/${
        this.url.importExcelUrl
      }`;
    }
  },
  // inject: ['reload'],
  methods: {
    seeGroupMember(record) {
      // console.log(record);
      getAction(this.url.groupChatMember, {
        chatId: record.chat_id
      }).then(res => {
        // console.log(res, 111);
        this.dataGroupChat = res.result;
      });
      this.visibleGroupMemberChat = true;
    },
    onCloseGroupChat() {
      this.visibleGroupMemberChat = false;
    },
    courseManage(record) {
      this.$refs.courseManageModal.add(record);
    },

    getAvatarView: function(avatar) {
      return getFileAccessHttpUrl(avatar);
    },
    jumpChatDataView: function(record) {
      console.log(record);
      this.$router.push({
        path: '/wechatwork/supervision/chatDataList',
        query: { roomId: record.chat_id, type: 2 }
      });
    },
    distribution(record) {
      this.$refs.customerWindow.add(record);
    },
    modalFormOk(data) {
      this.checkedDepartNames = [];
      this.selectedDepartKeys = [];
      this.departIds = [];
      for (var i = 0; i < data.departIdList.length; i++) {
        this.selectedDepartKeys.push(data.departIdList[i].key);
        this.checkedDepartNames.push(data.departIdList[i].title);
        this.departIds.push(data.departIdList[i].key);
      }
      // let formData1 = new FormData();
      // var charlist = [];
      // // charlist.push(formData.key)
      // // formData1.chat_id_list = charlist;
      // formData1.new_owner = this.selectedDepartKeys[0]
      var charlist = [];
      charlist.push(data.key);
      let formData = {
        chat_id_list: charlist,
        new_owner: this.selectedDepartKeys[0]
      };
      this.confirmLoading = true;
      transfer(formData).then(res => {
        if (res.success && res.result.hasOwnProperty('failed_chat_list')) {
          this.$message.success('继承成功');
        } else {
          this.$message.success(
            '未成功' +
              failed_chat_list.length +
              '项,请核查该成员是否激活企业微信,设置实名,配置了客户联系功能'
          );
        }
        this.confirmLoading = false;
        this.searchReset();
        // this.reload()
        this.close();
      });
      this.userDepartModel.departIdList = this.selectedDepartKeys;
      this.checkedDepartKeys = this.selectedDepartKeys; //更新当前的选择keys
      // this.reload()
      this.searchReset();
    },
    handleMenuClick(e) {
      console.log('点击批量删除按钮');
      if (e.key === '1') {
        console.log('批量删除');
        this.batchDel();
      }
    },
    // 上传二维码
    uploadCode(record) {
      this.visibleCode = true;
      // console。log(record)
      this.groupChatId = record.chat_id;
    },
    handleOkCode() {
      // console.log(this.multipartFile)
      postAction(this.url.fileUpload, {
        imageName: this.multipartFile,
        groupId: this.groupChatId,
        url: this.codeUrl
      }).then(res => {
        if (res.success) {
          this.visibleCode = false;
          this.picUrl = '';
          this.$message.success('上传成功');
          this.loadData();
        }
      });
    },
    handleCancelCode() {
      this.visibleCode = false;
      this.picUrl = '';
    },
    openCode(record) {
      postAction(this.url.showGroupDimensionalBarcode, {
        groupId: record.chat_id
      }).then(res => {
        console.log(res, 22222);
        this.URL = res.result;
      });
      this.visibleOpenCode = true;
    },
    _getFileList(e) {
      console.log(e);
      if (e[e.length - 1].response.success) {
        this.multipartFile = e[e.length - 1].response.result.imageName;
      }
      this.codeUrl = e[e.length - 1].url;
    },
    showDetial(a) {
      console.log(a);
      this.showorhidden = !this.showorhidden;
      this.record = a;
    }
  }
};
</script>

<style scoped>
@import '~@assets/less/common.less';
</style>
